import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/templates/HeadlineMetrics.tsx
// Top KPI row for the analyst-report Sheet — 3-5 stat cards with bigger
// values, label below value, and an optional lucide trend icon.
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
function trendClass(trend) {
    if (trend === "up")
        return "text-emerald-400";
    if (trend === "down")
        return "text-rose-400";
    return "text-slate-100";
}
function TrendIcon({ trend }) {
    if (trend === "up")
        return _jsx(TrendingUp, { className: "h-3.5 w-3.5 text-emerald-400" });
    if (trend === "down")
        return _jsx(TrendingDown, { className: "h-3.5 w-3.5 text-rose-400" });
    if (trend === "neutral")
        return _jsx(Minus, { className: "h-3.5 w-3.5 text-slate-500" });
    return null;
}
export function HeadlineMetrics({ metrics }) {
    if (!Array.isArray(metrics) || metrics.length === 0)
        return null;
    return (
    // Auto-fit grid: each card has min-width 9rem, fills any extra width
    // proportionally. Numbers can be huge ("$4,825,000") or short ("1.20") —
    // the value font-size is fluid so neither extreme breaks the layout.
    _jsx("div", { className: "mt-2 grid gap-3", style: { gridTemplateColumns: "repeat(auto-fit, minmax(9rem, 1fr))" }, children: metrics.map((m, i) => (_jsxs("div", { className: "rounded-lg border border-slate-700/60 bg-slate-900/60 p-3 min-w-0", children: [_jsxs("div", { className: "flex items-center gap-1.5 min-w-0", children: [_jsx("div", { className: `font-semibold tabular-nums truncate ${trendClass(m.trend)}`, style: { fontSize: "clamp(1rem, 4.5vw, 1.5rem)", lineHeight: 1.15 }, title: m.value, children: m.value }), _jsx(TrendIcon, { trend: m.trend })] }), _jsx("div", { className: "text-[11px] uppercase tracking-wider text-slate-400 mt-1 break-words", children: m.label })] }, i))) }));
}
